
export function buttonStyles(){
  return [{i:'primary'}, {i:'secondary'},{i:'success'}, {i:'danger'}, {i:'warning'}, {i:'info'}, {i:'light'}, {i:'dark'}, {i:'link'}, {i:'pastelYellow'}, {i:'pastelGreen'}, {i:'pastelMint'}, {i:'pastelBlue'}, {i:'pastelPink'}, {i:'pastelPurple'}, {i:'pastelBrown'}, {i:'normalLightYellow'}, {i:'normalLightOrange'}, {i:'normalLightGreen'}, {i:'normalLightBlue'}, {i:'normalLightPink'}, {i:'normalLightPurple'}, {i:'normalLightBrown'}, {i:'normalLightRed'}, {i:'normalLightGrey'}, {i:'normalDarkYellow'}, {i:'normalDarkOrange'}, {i:'normalDarkGreen'}, {i:'normalDarkBlue'}, {i:'normalDarkPink'}, {i:'normalDarkPurple'}, {i:'normalDarkBrown'}, {i:'normalDarkRed'}, {i:'normalDarkGrey'}];
}

export function getSessionIDEtc(sessionIDUserIDVPassword){
  var splitPieces = sessionIDUserIDVPassword.split(" ") 
  var sessionID = +splitPieces[0];
  var userID = +splitPieces[1];
  var vPassword = splitPieces[2];
  return {sessionID, userID, vPassword};
}

export function downloadFile(name, csv){
    var textFile = null,
    makeTextFile = function (text) {
      var data = new Blob([text], {type: 'text/plain'});

      // If we are replacing a previously generated file we need to
      // manually revoke the object URL to avoid memory leaks.
      if (textFile !== null) {
        window.URL.revokeObjectURL(textFile);
      }

      textFile = window.URL.createObjectURL(data);

      // returns a URL you can use as a href
      return textFile;
    };   
      var link = document.createElement('a');
      link.setAttribute('download', name);
      link.href = makeTextFile(csv);
      document.body.appendChild(link);

      // wait for the link to be added to the document 
        var event = new MouseEvent('click');
        link.dispatchEvent(event);
        document.body.removeChild(link);
}

export function copyToClipboard(text){
  return function(e){
    navigator.clipboard.writeText(text);
  }
}

export function convertToGrid(lines, size, fillGaps){
    var smallArray = [];
    if (lines){
      for (var i=0; i< lines.length; i+=size) {
          smallArray.push(lines.slice(i,i+size));
          // do something with smallarray
      }
      if (fillGaps){
        if (smallArray.length > 0){
          var last = smallArray[smallArray.length-1];
          if (last){
            var nowLength = last.length;
            for (var j = nowLength; j < size; j++){
              last.push(null);
            }            
          }
        }      
      }      
    }

  return smallArray;  
}


export function isEthAddress(address) {
    if (!/^(0x)?[0-9a-f]{40}$/i.test(address)) {
        // check if it has the basic requirements of an address
        return false;
    } else if (/^(0x)?[0-9a-f]{40}$/.test(address) || /^(0x)?[0-9A-F]{40}$/.test(address)) {
        // If it's all small caps or all all caps, return true
        return true;
    } else {
      return true;
        // Otherwise check each case
        // return isChecksumAddress(address);
    }
};

export function isEthTransaction(address) {
    if (!/^(0x)?[0-9a-f]{80}$/i.test(address)) {
        // check if it has the basic requirements of a transaction
        return false;
    } else if (/^(0x)?[0-9a-f]{80}$/.test(address) || /^(0x)?[0-9A-F]{80}$/.test(address)) {
        // If it's all small caps or all all caps, return true
        return true;
    } else {
      return true;
        // Otherwise check each case
        // return isChecksumAddress(address);
    }
};

// function isTroAddress (address) {
//     if (!/^[0-9a-f]+$/i.test(address)) {
//         // check if it has the basic requirements of an address
//         return false;
//     } else {
//       return true;
//         // Otherwise check each case
//         // return isChecksumAddress(address);
//     }
// };

export function isReservedWord(thisVal){
  var arr = ['addr1', 'addr2', 'addrs', 'owner', 'testcontract', 'describe', 'let', 'const'];
  var lower = thisVal.toLowerCase();
  for (var i = 0; i < arr.length; i++){
    if (lower.indexOf(arr[i]) > -1){
      return  true;
    }
  }
  return false;
}
export function letterNumbersNotStartingWitNumber(thisVal){
  if (thisVal && (typeof thisVal === 'string' || thisVal instanceof String)){
    var regex3 = /^[a-zA-Z][a-zA-Z0-9]*$/
    return thisVal.match(regex3);    
  }else{
    return false;
  }
}

export function letterNumbersSpacesNotStartingWitNumber(thisVal){
  if (thisVal && (typeof thisVal === 'string' || thisVal instanceof String)){
    var regex3 = /^[a-zA-Z][a-zA-Z0-9 ]*$/
    return thisVal.match(regex3);    
  }else{
    return false;
  }
}

export function startsWithLetter(thisVal){
  if (thisVal && (typeof thisVal === 'string' || thisVal instanceof String)){
    var regex3 = /^[a-zA-Z]/
    return thisVal.match(regex3);    
  }else{
    return false;
  }
}

export function isAlphaNumeric(thisVal){
  if (thisVal && (typeof thisVal === 'string' || thisVal instanceof String)){
    var regex3 = /^[a-zA-Z0-9_]*$/
    return thisVal.match(regex3);    
  }else{
    return false;
  }
}
export function isAlphaNumericPlus(thisVal){
  if (thisVal && (typeof thisVal === 'string' || thisVal instanceof String)){
    var regex3 = /^[a-zA-Z0-9_. ,]*$/
    return thisVal.match(regex3);    
  }else{
    return false;
  }
}
export function isValidHTML(thisVal){
  if (thisVal && (typeof thisVal === 'string' || thisVal instanceof String)){
    var regex3 = /^[a-zA-Z0-9_.:\\/]*$/
    return thisVal.match(regex3);    
  }else{
    return false;
  }
}

export function isIntegerText(thisVal){
  if (thisVal && (typeof thisVal === 'string' || thisVal instanceof String)){
    var regex3 = /^([-]?[1-9]\d*|0)$/
    return thisVal.match(regex3);    
  }else{
    return false;
  }
}

export function isIntegerTextWithCover(thisVal){
  if (thisVal && (typeof thisVal === 'string' || thisVal instanceof String)){
    if (thisVal.substr(0, 1) === '+' || thisVal.substr(0, 1) === '-'){
      thisVal = thisVal.substr(1);
      var regex3 = /^([1-9]\d*|0)$/
      return thisVal.match(regex3);    
    }
  }
  return false;
}


export function isDecimalText(thisVal){
  if (thisVal && (typeof thisVal === 'string' || thisVal instanceof String)){
    var regex3 = /^[+-]?([0-9]+\.?[0-9]*|\.[0-9]+)$/
    return thisVal.match(regex3);    
  }
  return false;
}




export function hexToRgb(hex) {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16)
  } : null;
}

export function isValidHexColor(thisVal){
  if (thisVal && (typeof thisVal === 'string' || thisVal instanceof String)){
    var regex3 = /^#[0-9A-F]{6}$/
    return thisVal.match(regex3);    
  }
  return false;
}

export function isPositiveNumberOrZeroText(thisVal){
  if (thisVal && (typeof thisVal === 'string' || thisVal instanceof String)){
    var regex3 = /^[+]?([0-9]+\.?[0-9]*|\.[0-9]+)$/
    return thisVal.match(regex3);    
  }
  return false;
}

export function isPositiveIntegerText(p){
  if (p){
    var regex3 = /^([1-9]\d*)$/
    return p.match(regex3);
  }else{
    return false;
  }
}

export function isPositiveIntegerOrZeroText(p){
  if (p === '0'){
    return true;
  }
  if (p){
    var regex3 = /^([1-9]\d*)$/
    return p.match(regex3);
  }else{
    return false;
  }
}

